import React, { useMemo } from "react";
import { Col, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import { get } from "lodash";
import PropTypes from "prop-types";

import Collapse from "./Collapse";
import { getOptionLabel } from "common/enums";
import ProposedProjectLocationEditField from "Components/ProposedProjectLocationEditField";

import { convertUTCDateToLocalDate } from "utils/convertUTCDateToLocalDate";

const mapBooleanToYesNo = (value) => {
  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }
  return "-";
};

const SolarDetailsView = ({ applicationId, solar, isExpandable = true, t }) => {
  const fields = useMemo(
    () => [
      {
        name: "Solar Holder Name",
        key: "developerName",
        isRequired: true,
      },
      {
        name: "Registration no. of GEDA",
        key: "gedaNumber",
        isRequired: true,
      },
      {
        name: "Approval No. of Chief Electrical Inspector (CEI)",
        key: "ceiApprovalNumber",
        isRequired: true,
      },
      {
        name: "Capacity of Solar",
        key: "capacity",
        isRequired: true,
        renderField: (value) => (value ? `${value} kW` : "-"),
      },
      {
        name: "Proposed Date",
        key: "proposedDate",
        renderField: (value) =>
          value ? convertUTCDateToLocalDate(value).format("DD-MM-YYYY") : "-",
        isRequired: true,
      },
      {
        name: "Type of Solar Power",
        key: "type",
        renderField: (value) =>
          value ? getOptionLabel("solarTypeOptions", value) : "-",
        isRequired: true,
      },
      {
        name: "End use of solar generated electricity",
        key: "endUse",
        renderField: (value) =>
          value ? getOptionLabel("solarUsagePurposeOptions", value) : "-",
        isRequired: true,
      },
      {
        name: "Energy Settlement option",
        key: "energySettlement",
        renderField: (value) =>
          value ? getOptionLabel("energySettlementOptions", value) : "-",
        isRequired: true,
      },
      {
        name: "Details of Existing Solar Capacity In The Premises",
        key: "existingSolarCapacity",
        isRequired: false,
      },
      {
        name: "Details of Other Power Generating Source In The Premises",
        key: "otherPowerCapacity",
        isRequired: false,
      },
      {
        name: "Other Open Access",
        key: "openAccess",
        renderField: (value) =>
          value ? getOptionLabel("openAccessPowerOptions", value) : "-",
        isRequired: true,
      },
      {
        name: "Project registered under REC mechanism",
        key: "isRegisteredREC",
        renderField: (value) => mapBooleanToYesNo(value),
        isRequired: true,
      },
      {
        name: "Address of proposed project location",
        key: "proposedProjectLocation",
        renderField: (value) => (
          <ProposedProjectLocationEditField
            applicationId={applicationId}
            proposedProjectLocation={value}
          />
        ),
        isRequired: true,
      },
    ],
    [applicationId]
  );
  return (
    <Collapse title="Solar Info" isExpandable={isExpandable}>
      <Row className="d-flex  mb-2 ">
        {fields.map(({ name, key, isRequired, renderField }) => {
          const value = get(solar, key, "");

          return (
            <Col key={key} lg={6} className="mb-1">
              <Row>
                <Col md={5}>{t(name)}:</Col>
                <Col
                  md={7}
                  className="fw-semibold"
                  style={{ wordBreak: "break-word" }}
                >
                  {renderField
                    ? renderField(value)
                    : get(solar, key, null) ?? (isRequired ? "-" : "N/A")}
                </Col>
              </Row>
            </Col>
          );
        })}
      </Row>
    </Collapse>
  );
};

SolarDetailsView.propTypes = {
  solar: PropTypes.object,
  applicationId: PropTypes.number,
  isExpandable: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(SolarDetailsView);
